import styled from "styled-components";

export const Error = styled.span`
  font-size: ${p => p.theme.typography.fontSizeS};
  line-height: 1.3;
  color: ${p => p.theme.colors.materialRedOp6};
`

export const Address = styled.span`
  font-size: ${p => p.theme.typography.fontSizeS};
  line-height: 1.3;
`
